import styled from 'styled-components'
import { motion } from 'framer-motion'
import { background } from 'styles/Colors'

export const Container = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 25;
  width: 100%;
  height: 80vh;
  height: 80dvh;
  display: flex;
  flex-direction: column;
  background-color: ${background};
`
